import { PipesModule } from "./../shared/pipes/pipes.module";
import { MultiselectModule } from "./../multiselect/multiselect.module";
import { InputModule } from "./../input/input.module";
import { TooltipModule } from "./../tooltip/tooltip.module";
import { CheckboxModule } from "./../checkbox/checkbox.module";
import { IconModule } from "../icon/icon.module";
import { TransitionModule } from "./../transition/transition.module";
import { PaginatorModule } from "./../paginator/paginator.module";
import { ButtonModule } from "./../button/button.module";
import { SnackbarModule } from "./../snackbar/snackbar.module";
import { DatatableGlobalSearcherComponent } from "./datatable-global-searcher/datatable-global-searcher.component";
import { DatatableColumnFilterComponent } from "./datatable-column-filter/datatable-column-filter.component";
import { DatatableAdvancedSearcherComponent } from "./datatable-advanced-searcher/datatable-advanced-searcher.component";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DatatableComponent } from "./datatable.component";

@NgModule({
	declarations: [
		DatatableComponent, DatatableAdvancedSearcherComponent, DatatableColumnFilterComponent, DatatableGlobalSearcherComponent
	],
	imports: [
		CommonModule,
		FormsModule,
		SnackbarModule,
		ButtonModule,
		PaginatorModule,
		TransitionModule,
		IconModule,
		CheckboxModule,
		TooltipModule,
		InputModule,
		MultiselectModule,
		PipesModule
	],
	exports: [
		DatatableComponent, DatatableAdvancedSearcherComponent, DatatableColumnFilterComponent, DatatableGlobalSearcherComponent
	]
})
export class DatatableModule { }
